import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  CreateUserApplicationRequestObjectType,
  CreateUserApplicationResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseCreateUserApplicationInterface {
  createUserApplicationApi: UseMutateAsyncFunction<
    CreateUserApplicationResponseType,
    Error,
    CreateUserApplicationRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useCreateUserApplicationApi = (): UseCreateUserApplicationInterface => {
  const { nwApplicationService } = useNwApplicationService();

  const createUserApplication = (
    requestObject: CreateUserApplicationRequestObjectType
  ) => {
    return nwApplicationService.createUserApplication(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(createUserApplication, {
    mutationKey: ['createUserApplicationApi']
  });

  const createUserApplicationApi = mutateAsync;

  return {
    createUserApplicationApi,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useCreateUserApplicationApi };
